import { Search } from "lucide-react";
import type { SingleValue } from "react-select";

import { Input } from "@/components/ui/input";
import { getSelectClasses } from "@/utils/filter-styles";
import { SelectInput } from "components/Select";

import { usePendingFilterActions } from "../ducks/filter/hooks/actions";
import { usePendingFilterState } from "../ducks/filter/hooks/filterState";

interface Option {
  value: string;
  label: string;
}

const TODOS: Option = { value: "", label: "Todos" };
const TODAS: Option = { value: "", label: "Todas" };

const TIPO_OPTIONS: Option[] = [
  TODOS,
  { value: "normal", label: "Normal" },
  { value: "promocao", label: "Promoção" },
];

interface PendingFilterProps {
  regions?: string[];
  showSearch?: boolean;
}

export function PendingFilter({
  regions = [],
  showSearch = false,
}: PendingFilterProps) {
  const { filters } = usePendingFilterState();
  const { updateFilter } = usePendingFilterActions();

  const resetPage = () => updateFilter({ key: "page", value: 1 });

  const regionOptions: Option[] = [
    TODAS,
    ...regions.map((regional) => ({ value: regional, label: regional })),
  ];

  const selected = (options: Option[], value: string | null) =>
    options.find((option) => option.value === (value ?? "")) ?? options[0];

  return (
    <div className="flex flex-wrap items-end gap-3">
      {regions.length > 0 && (
        <div className="flex flex-col gap-0.5">
          <span className="text-xs font-medium text-muted-foreground">
            Regional / UF
          </span>
          <SelectInput
            options={regionOptions}
            value={selected(regionOptions, filters.region)}
            onChange={(option: SingleValue<Option>) => {
              updateFilter({ key: "region", value: option?.value || null });
              resetPage();
            }}
            className={`${getSelectClasses(!!filters.region)} h-8 min-w-[190px]`}
            classNamePrefix="an-simple-select"
            isClearable={false}
            isSearchable={false}
          />
        </div>
      )}

      {showSearch && (
        <div className="flex flex-col gap-0.5">
          <span className="text-xs font-medium text-muted-foreground">
            Buscar loja
          </span>
          <div className="relative w-[220px]">
            <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
            <Input
              value={filters.search}
              onChange={(event) =>
                updateFilter({ key: "search", value: event.target.value })
              }
              placeholder="código ou cidade"
              className="h-8 pl-8"
            />
          </div>
        </div>
      )}

      <div className="flex flex-col gap-0.5">
        <span className="text-xs font-medium text-muted-foreground">Tipo</span>
        <SelectInput
          options={TIPO_OPTIONS}
          value={selected(TIPO_OPTIONS, filters.labelType)}
          onChange={(option: SingleValue<Option>) => {
            updateFilter({ key: "labelType", value: option?.value || null });
            resetPage();
          }}
          className={`${getSelectClasses(!!filters.labelType)} h-8 min-w-[150px]`}
          classNamePrefix="an-simple-select"
          isClearable={false}
          isSearchable={false}
        />
      </div>
    </div>
  );
}

export default PendingFilter;
